// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--3d06e";
export var btn = "index-module--btn--1dafe";
export var container = "index-module--container--f40ca";
export var header = "index-module--header--8cbd7";
export var image = "index-module--image--cb494";
export var item = "index-module--item--b76ab";
export var media = "index-module--media--0f51e";
export var navigation = "index-module--navigation--e79a8";
export var next = "index-module--next--7694f";
export var player = "index-module--player--03430";
export var prev = "index-module--prev--33320";
export var title = "index-module--title--626fd";
export var wrapper = "index-module--wrapper--430d9";